import React from 'react';
import css from 'styled-jsx/css';
import SliderSimilar from '../SliderSimilar';
import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';

const OtherImages = ({ t, title, collection, href, as, loading }) => {
  if (loading) {
    return (
      <section className="other-images">
        <h2
          className="title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <LoadingSpinner />
        <style jsx>{styles}</style>
      </section>
    );
  }

  if (!collection || collection.length === 0) {
    return null;
  }

  return (
    <section className="other-images">
      <h2
        className="title"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      <SliderSimilar images={collection} isMain />
      {as && href && (
        <I18nLink as={as} href={href}>
          <a
            className={`btn btn-ac-primary btn-${config.serviceType} btn-see-more`}
          >
            {t('More')}
          </a>
        </I18nLink>
      )}
      <style jsx>{styles}</style>
    </section>
  );
};

const styles = css`
  .other-images {
    padding: ${themeVariables.space.half}px ${themeVariables.space.base}px;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: ${themeVariables.fontSize.base}px;
  }

  .btn-see-more {
    font-size: ${themeVariables.fontSize.medium}px;
    padding: ${themeVariables.space.half}px ${themeVariables.space.medium}px;
    align-self: center;
    margin-top: ${themeVariables.space.half}px;
  }
`;

export default withI18next()(OtherImages);
